
import { defineComponent, PropType } from 'vue';
import { MediaModel } from '@/typings';
import { ElTooltip } from 'element-plus';

export default defineComponent({
    components: {
        ElTooltip
    },
    props: {
        mediaInfo: {
            type: Object as PropType<MediaModel>,
            required: true
        }
    }
});

